// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ax-sunny {
  width: 180px;
  position: fixed;
  right: -20px;
  bottom: 0;
  z-index: 10;
  transition: all 0.4s ease;
}
.ax-sunny--hidden {
  opacity: 0;
  visibility: hidden;
}
.ax-sunny-content {
  padding: 16px;
  width: 210px;
  position: absolute;
  top: -40px;
  left: -180px;
  z-index: -1;
  background-color: var(--ion-color-light);
  color: var(--ion-text-color);
  border-radius: 4px;
  background-clip: padding-box;
  box-shadow: 0 3px 30px -10px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  transform: rotate(-4deg);
}
.ax-sunny-content h2 {
  color: var(--ion-color-primary);
}
.ax-sunny-content :first-child {
  margin-top: 0;
}
.ax-sunny-content :last-child {
  margin-bottom: 0;
}
.ax-sunny-image {
  max-width: 100%;
  height: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/components/ax-sunny/ax-sunny.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;AACF;AACE;EACE,UAAA;EACA,kBAAA;AACJ;AAEE;EACE,aAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,wCAAA;EACA,4BAAA;EACA,kBAAA;EACA,4BAAA;EACA,+CAAA;EACA,yBAAA;EACA,wBAAA;AAAJ;AAEI;EACE,+BAAA;AAAN;AAGI;EACE,aAAA;AADN;AAII;EACE,gBAAA;AAFN;AAME;EACE,eAAA;EACA,YAAA;AAJJ","sourcesContent":[".ax-sunny {\n  width: 180px;\n  position: fixed;\n  right: -20px;\n  bottom: 0;\n  z-index: 10;\n  transition: all 0.4s ease;\n\n  &--hidden {\n    opacity: 0;\n    visibility: hidden;\n  }\n\n  &-content {\n    padding: 16px;\n    width: 210px;\n    position: absolute;\n    top: -40px;\n    left: -180px;\n    z-index: -1;\n    background-color: var(--ion-color-light);\n    color: var(--ion-text-color);\n    border-radius: 4px;\n    background-clip: padding-box;\n    box-shadow: 0 3px 30px -10px rgb(0 0 0 / 30%);\n    transition: all 0.3s ease;\n    transform: rotate(-4deg);\n\n    h2 {\n      color: var(--ion-color-primary);\n    }\n\n    :first-child {\n      margin-top: 0;\n    }\n\n    :last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  &-image {\n    max-width: 100%;\n    height: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
